import { render, staticRenderFns } from "./IconLanguageComponent.vue?vue&type=template&id=4d019b9c"
import script from "./IconLanguageComponent.vue?vue&type=script&lang=js"
export * from "./IconLanguageComponent.vue?vue&type=script&lang=js"
import style0 from "./IconLanguageComponent.vue?vue&type=style&index=0&id=4d019b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports